/**
 * Onboarding Form Options
 * Data for the 3-step onboarding wizard
 */

import {
  Briefcase,
  UserCheck,
  Palette,
  Code2,
  Megaphone,
  DollarSign,
  Settings,
  Sparkles,
  BarChart3,
  Users,
  Wrench,
  List
} from 'lucide-react';

// Step 1: Team/Persona Selection
export const TEAM_OPTIONS = [
  {
    id: 'sales',
    label: 'Sales',
    description: 'AE, SDR, SE, RevOps',
    icon: Briefcase
  },
  {
    id: 'customer_success',
    label: 'Customer Success',
    description: 'CSA, Renewals',
    icon: UserCheck
  },
  {
    id: 'product',
    label: 'Product',
    description: 'PM, Analyst, Designer',
    icon: Palette
  },
  {
    id: 'engineering',
    label: 'Engineering',
    description: 'Engineering',
    icon: Code2
  },
  {
    id: 'marketing',
    label: 'Marketing',
    description: 'Marketing, MarketingOps',
    icon: Megaphone
  },
  {
    id: 'finance',
    label: 'Finance',
    description: 'Finance, Controller',
    icon: DollarSign
  },
  {
    id: 'it_admin',
    label: 'IT / Admin',
    description: 'IT Admin, IT Ops',
    icon: Settings
  },
  {
    id: 'anyone',
    label: 'Anyone',
    description: 'I wear many hats',
    icon: Sparkles
  },
];

// Step 2: Role Selection (organized by Leadership/Operations)
export const ROLE_OPTIONS = {
  leadership: [
    { id: 'bdr', label: 'BDR' },
    { id: 'ae', label: 'AE' },
    { id: 'sales_engineer', label: 'Sales Engineer' },
    { id: 'tam', label: 'TAM' },
    { id: 'technical_onboarding', label: 'Technical Onboarding' },
    { id: 'global_strategic_pursuits', label: 'Global Strategic Pursuits' },
  ],
  operations: [
    { id: 'channel_manager', label: 'Channel Manager' },
    { id: 'account_manager', label: 'Account Manager' },
    { id: 'csm', label: 'CSM' },
    { id: 'professional_services', label: 'Professional Services' },
    { id: 'retention', label: 'Retention' },
  ]
};

// Step 3: Hub Organization Preference
export const HUB_ORGANIZATION_OPTIONS = [
  {
    id: 'by_sales_stage',
    label: 'By sales stage',
    description: 'See tools mapped to where you are in the deal cycle',
    icon: BarChart3
  },
  {
    id: 'by_role',
    label: 'By role',
    description: 'Tools curated for each role around you',
    icon: Users,
    highlight: true // This appears highlighted in the screenshots
  },
  {
    id: 'by_capability',
    label: 'By capability',
    description: 'Grouped by what they do — research, generate, analyze',
    icon: Wrench
  },
  {
    id: 'no_grouping',
    label: 'No grouping',
    description: 'One flat list, filter when you need to narrow',
    icon: List
  },
];
